import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { SafeComponent } from '@fiverr-private/orca';
import ServiceItem from '../ServiceItem';
import { useAppContext } from '../../context/AppContext';
import { DEFAULT_POPULAR_SERVICES, POPULAR_SERVICES_FOR_EN } from './constants';

const PopularServices = () => {
    const { withEnglishBAL } = useAppContext();

    const servicesToRender = withEnglishBAL ? POPULAR_SERVICES_FOR_EN : DEFAULT_POPULAR_SERVICES;

    return (
        <Stack
            direction="row"
            gap="4"
            wrap={{ default: 'nowrap', sm: 'wrap' }}
            overflow="auto"
            justifyContent="flexStart"
            width="100%"
        >
            {servicesToRender.map(({ label, href, eventName, isNew }, index) => (
                <ServiceItem label={label} href={href} key={label} eventName={eventName} index={index} isNew={isNew} />
            ))}
        </Stack>
    );
};

export default SafeComponent(PopularServices);
